<template>
  <div class="card-block">
      <div class="form-group row pt-2 mx-2" style="background-color: #f9f9f9; padding: 14px; border-radius: 5px; border: solid 1px #efefef;">
        <div class="col-md-12">
          <strong><i class="fas fa-tasks"></i> {{$lang.Documents.History.TitleForm}}</strong>
        </div>
        <div class="col-md-12">
          <div class="table-responsive pt-4">
            <table class="table table-hover">
              <thead class="thead-default">
                <th class="text-center">{{$lang.Documents.History.LabelDate}}</th>
                <th class="text-center">{{$lang.Documents.History.LabelAccount}}</th>
                <th class="text-center">{{$lang.Documents.History.LabelAction}}</th>
              </thead>
              <tbody v-if="list">
                <tr v-for="(obj, index) in list" :key="index">
                  <td class="text-center">{{formatDate(obj.data)}}</td>
                  <td class="text-center">{{obj.conta.nome}}</td>
                  <td class="text-center">{{obj.descricao}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="1" class="text-center">{{$lang.Common.DataTable.NoRecordsFound}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import GedFolderHistoryRepository from '@/shared/http/repositories/business/gedfolderhistory'
import { loading } from '@/shared/utils/UIHelper'
export default {
  name: 'folderHistory',
  data () {
    return {
      list: []
    }
  },
  methods: {
    formatDate (str) {
      const date = new Date(str)
      return date.toLocaleString()
    },
    load (folder) {
      loading.push()
      GedFolderHistoryRepository.GetAll(folder.id)
        .then(response => {
          if (response.data.code > 0) {
            this.list = response.data.data
            loading.pop()
          }
        })
        .catch(err => {
          console.log(err)
          loading.pop()
        })
    }
  }
}
</script>

<style scoped>
table tbody tr td {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/content/folderhistory.vue